<template>
  <div class="date-selector">
    <v-label class="form-label safe-trip-font"> {{ label }}</v-label>
    <v-menu
      v-model="dateMenuDisplayed"
      :close-on-content-click="false"
      transition="scale-transition"
      location="bottom"
      min-width="auto"
    >
      <template #activator="{ props }">
        <v-text-field
          v-bind="props"
          id="date-selector-text-field"
          v-model="formattedDate"
          :label="label"
          prepend-icon="fa:fa fa-calendar"
          clear-icon="mdi-close"
          readonly
          clearable
          :disabled="disabled"
          density="compact"
          variant="underlined"
          color="primary"
          class="date-selector-text-field"
          @click:clear="onClearDate"
        ></v-text-field>
      </template>
      <v-date-picker
        id="date-selector-date-picker"
        v-model="selectedDate"
        :allowed-dates="checkAllowedDates"
        :disabled="disabled"
        hide-header
        color="primary"
      >
        <template #actions>
          <cs-button
            id="date-selector-date-picker-cancel"
            label="Cancel"
            @click="cancelUpdateDate()"
          ></cs-button>
          <cs-button
            id="date-selector-date-picker-ok"
            primary
            label="OK"
            @click="updateDate()"
          ></cs-button>
        </template>
      </v-date-picker>
    </v-menu>
  </div>
</template>
<script>
import moment from 'moment-timezone';

export default {
  name: 'DateSelector',
  props: {
    modelValue: {
      type: String,
      required: true
    },
    id: { type: String, default: '' },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowedDates: {
      type: Function,
      default: () => []
    }
  },

  emits: ['update:modelValue'],

  data() {
    return {
      dateMenuDisplayed: false,
      selectedDate: null
    };
  },
  computed: {
    formattedDate() {
      return this.selectedDate ? moment(this.selectedDate).format('DD/MM/YYYY') : '';
    }
  },
  watch: {
    modelValue(newValue) {
      this.selectedDate = this.toDateValue(newValue);
    }
  },
  async mounted() {
    this.selectedDate = this.toDateValue(this.modelValue);
  },
  methods: {
    toDateValue(strDate) {
      if (!strDate) {
        return null;
      }
      if (strDate.includes('-')) {
        return moment(strDate, 'YYYY-MM-DD').toDate();
      }
      return moment(strDate, 'DD/MM/YYYY').toDate();
    },
    updateDate() {
      const retDate = this.selectedDate ? moment(this.selectedDate).format('YYYY-MM-DD') : '';
      this.dateMenuDisplayed = false;
      this.$emit('update:modelValue', retDate);
    },
    onClearDate() {
      this.selectedDate = null;
      this.updateDate();
    },
    cancelUpdateDate() {
      this.dateMenuDisplayed = false;
      this.selectedDate = this.toDateValue(this.modelValue);
    },
    checkAllowedDates(date) {
      const strDate = moment(date).format('YYYY-MM-DD');
      if (this.allowedDates) {
        return this.allowedDates(strDate);
      }
      return true;
    }
  }
};
</script>
<style scoped>
.date-selector-text-field .v-label {
  font-weight: 500;
  font-size: 10px !important;
}

.date-selector-text-field label {
  font-weight: 500;
  font-size: 10px !important;
}

.date-selector-text-field .v-label {
  font-weight: 500;
  font-size: 10px !important;
}
</style>
